export default {
  desktop: {
    ThemeImporter: () => import(/* webpackChunkName: "reisbet-themeWrap" */'./ThemeImporter'),
  },
  mobile: {
    ThemeImporter: () => import(/* webpackChunkName: "reisbet-themeWrap" */'./ThemeImporter'),
  },
};
